const LOG_LIMIT = 50;
const logBuffer = [];

let isInitialized = false;

export const telemetryUrl = value => {
  try {
    const url = new URL(typeof value === 'string' ? value : value?.url, window.location.origin);
    return `${url.origin}${url.pathname}`;
  } catch (_) { return '[unavailable URL]'; }
};
const safeLogValue = value => {
  const text = typeof value === 'object' ? JSON.stringify(value, (key, entry) =>
    /token|authorization|secret|password|signature/i.test(key) ? '[redacted]' : entry) : String(value);
  return text.replace(/https?:\/\/[^\s"'<>]+|\/[^\s"'<>]*[?#][^\s"'<>]*/gi, telemetryUrl);
};

const addLog = (level, args) => {
  try {
    const message = args.map(safeLogValue).join(' ');
    logBuffer.push({ timestamp: new Date().toISOString(), level, message });
    if (logBuffer.length > LOG_LIMIT) {
      logBuffer.shift();
    }
  } catch (e) {
    // Ignore serialization errors to avoid infinite loops
  }
};

export const initTelemetry = () => {
  if (isInitialized) return;
  isInitialized = true;

  const originalError = console.error;
  const originalWarn = console.warn;

  console.error = (...args) => {
    addLog('error', args);
    originalError.apply(console, args);
  };

  console.warn = (...args) => {
    addLog('warn', args);
    originalWarn.apply(console, args);
  };

  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    try {
      const response = await originalFetch(...args);
      if (!response.ok) {
        addLog('fetch_error', [`HTTP ${response.status} on ${telemetryUrl(args[0])}`]);
      }
      return response;
    } catch (error) {
      addLog('fetch_error', [`Network error on ${telemetryUrl(args[0])}`]);
      throw error;
    }
  };
};

export const getTelemetryData = () => {
  return {
    logs: [...logBuffer],
    metadata: {
      browser: navigator.userAgent,
      os: navigator.platform,
      url: telemetryUrl(window.location.href),
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      viewportSize: `${window.innerWidth}x${window.innerHeight}`
    }
  };
};
